import React from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';
import { Link, useNavigate} from 'react-router';

import telasParaCortina from '../../src/data/todosLosProductos/telasParaCortina';
import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import imgLavado1 from '../assets/img/lavado/1.png'
import imgLavado2 from '../assets/img/lavado/2.png'
import imgLavado3 from '../assets/img/lavado/3.png'
import imgLavado4 from '../assets/img/lavado/4.png'
import imgLavado5 from '../assets/img/lavado/5.png'
import imgLavado6 from '../assets/img/lavado/6.png'
import imgLavado7 from '../assets/img/lavado/7.png'
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const TelasParaCortina = () => {
    const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Telas para Cortina y Confección | Hi Blinds</title>
            <meta name="description" content="Gran variedad de telas: Galaga, Lunet, Serenade, Chiffon, Voile y más. Ideales para confección y decoración." />
            <meta property="og:title" content="Telas para Cortina y Confección | Hi Blinds" />
            <meta property="og:description" content="Telas elegantes y funcionales para cortinas personalizadas. Calidad garantizada." />
            <meta property="og:url" content="https://hiblindsmx.com/telas-para-cortina-y-confeccion" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <h1>Telas para cortina y confección</h1>
                    <BtnVolverAnim Ref='/' />
                    
                <ContainerProductos>
                    {telasParaCortina.filter(p => p.categoria === 'Telas para cortina')
                    .map((producto, index) =>  {

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/telas-para-cortina-y-confección/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}>
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho: {producto.anchoRollo}</p>
                                <Link to={`/telas-para-cortina-y-confección/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                    <h2 style={{textAlign: 'center'}}>Confección de cortinas</h2>
                <ContainerProductos>
                    {telasParaCortina.filter(p => p.categoria === 'Confección de cortinas')
                    .map((producto, index) =>  {

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/telas-para-cortina-y-confección/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}>
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Tipo: {producto.tipo}</p>
                                <Link to={`/telas-para-cortina-y-confección/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                <H2GuiaLavado>Guia de lavado</H2GuiaLavado>
                <GuiaDeLavado>
                    <h3>Para que tus cortinas tengan un mayor
                        ciclo de vida, te recomendamos los siguientes
                        puntos para su cuidado
                        Solamente aplican en los Tergales
                    </h3>
                    <Lavado><img src={imgLavado1} alt='lavadoImg'/> <h4>Ciclo de Lavado normal</h4></Lavado>
                    <Lavado><img src={imgLavado2} alt='lavadoImg'/> <h4>No usar blanqueador</h4></Lavado>
                    <Lavado><img src={imgLavado3} alt='lavadoImg'/> <h4>No lavar en Seco</h4></Lavado>
                    <Lavado><img src={imgLavado4} alt='lavadoImg'/> <h4>Temperatura de Agua Max 40° C  (105° F)</h4></Lavado>
                    <Lavado><img src={imgLavado5} alt='lavadoImg'/> <h4>Temperatura de Planchado Max 110° C  (230° F)</h4></Lavado>
                    <Lavado><img src={imgLavado6} alt='lavadoImg'/> <h4>Ciclo de secado suave/delicado</h4></Lavado>
                    <Lavado><img src={imgLavado7} alt='lavadoImg'/> <h4>No Exprimir</h4></Lavado>
                </GuiaDeLavado>
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡Revisa nuestras telas para cortina!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
        </>
     );
}
const H2GuiaLavado = styled.h2 `
    text-align: center;
    margin-top: 15px;
`
const GuiaDeLavado = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin-top: 10px;

    h3 {
        text-align: center;
        margin: 0 10px;
        margin-bottom: 10px;
    }
`
const Lavado = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    width: 90%;
    gap: 20px;
    border: 2px solid #222;
    border-radius: 10px;

    img {
        height: 50px;
    }
`

export default TelasParaCortina;